import type { FaireProductEntity } from "../../entity_types/product";

export const p_yrjy3wmgqk: FaireProductEntity = {
  token: "p_yrjy3wmgqk",
  type: "product",
  name: "Pure Magnesium Oil | Relaxation | Post-Workout Recovery",
  brandToken: "b_v59f599x2t",
  brandName: "Plant of Life",
  imageUrl: "https://cdn.faire.com/fastly/b729a28470c9fd2166eedea3f3f1c314da6a34453c5c7c5fce689aa6efef7ff9.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2e3d63ebe330dc8dbdeb3d811336adf1459fcdb099348dca9b0e09d3387a8af3.jpeg",
    "https://cdn.faire.com/fastly/b69c5f1f8e7723c6e6ef87b9c1371fe7c2258053f4bd00f9985c290390e4551a.jpeg",
    "https://cdn.faire.com/fastly/40977f8685e04457c5cb9ec1a44ea58b1de781e0717b3eb3a597bca0ec97ac8f.jpeg",
    "https://cdn.faire.com/fastly/5887fa9c621763f3754d051124cc943b781ff2d165cb9fb65fc40809655f83c3.jpeg",
    "https://cdn.faire.com/fastly/410f50e27607d4fcdb203d68e41541a5979d0dc9c4fbe608d8e55ee4cf3f7cf6.jpeg",
    "https://cdn.faire.com/fastly/c5a79954be0c50b40255fe037ecad394a59f6543e73adcc653a35691bd9b798f.jpeg"
  ],
  priceDollars: 13.86,
  description: "Description:\n\nPUREST MAGNESIUM OIL: Plant of Life Magnesium Oil is a source of pure, elemental, magnesium drawn from the virgin depth of one of the world's most ancient landmarks: the Dead Sea. The rich deposits of magnesium chloride accumulated & naturally risen over a millennium offer an unparalleled source of nature's purest magnesium\n\nREPLENISHING YOUR BODY'S MAGNESIUM -  Form of transdermal, ionic Magnesium absorbed through your entire body. Magnesium is an essential mineral for various bodily processes, such as helping with sore muscles, leg cramps & post-workout recovery.\n\nNO ADDED INGREDIENTS - Concentrated source of pure Magnesium oil with minimal water required to maintain its liquid, ionic state at room temperature. \n\nSPRAY ON THE GO - Portable & easy to use at home or work when you need it the most.\n\nFOR DAY & NIGHT - Ideal for restless nights or even between your busiest morning schedules.\n\n",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:10.586Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
